import React from "react";

import BasicPill from "./basic_pill";
import css from "./pill.module.scss";

const MisalignmentPill = () => <BasicPill className={css.misalignmentPill} />;

export default MisalignmentPill;
